import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../configuration/configuration.service';
import { of, Subject } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { BOOKS_MAPPING, FROZEN_BOOKS_MAPPINGS } from '@app/_shared/modules/table-columns/table-columns-mappings';
import { RearrangeColumnsComponent } from '@app/_shared/modules/table-columns/components/rearrange-columns/rearrange-columns.component';
import { remove } from 'lodash-es';
import { BookType } from '@app/modules/trading/modules/books/books.enums';
import { AuthRole, AuthService } from '@app/modules/auth';
import { AffiliateBookType } from '@app/modules/affiliate/structs/affiliate.structs';
import { ShowPromotePlan } from '@app/_shared/shared.enums';

//keeping data type any . to be converted in service
interface SetCacheRequestParams {
    key: string;
    data: any;
}


@Injectable({
    providedIn: 'root'
})

export class TableColumnsService {

    bookColumnsMap = new Map<string, string[]>();
    is_dealer = this.authService?.accessTokenObj?.role === AuthRole.SUPERDEALER;

    constructor(
        private http: HttpClient,
        private configurationService: ConfigurationService,
        private authService: AuthService
    ) {
    }

    getColumns(tableName: string) {
        if (this.bookColumnsMap.has(tableName)) {
            return of(this.bookColumnsMap.get(tableName));
        }
        return this.http.get<any>(this.configurationService.applicationUrls.getCache, {
            params: {
                key: tableName
            }
        }).pipe(
            map((res: string) => {
                let expectedBookColumns: string[] = BOOKS_MAPPING[tableName];
                let response: string[] = res['data'] ? JSON.parse(res['data']) : [];
                console.log(tableName, response, expectedBookColumns);

                //handeling the case of normal dealer login_source coloumn is not required for the same.
                if (!this.is_dealer && tableName === AffiliateBookType.STATUS) {
                    expectedBookColumns = expectedBookColumns.filter((val) => val !== 'login_source');
                    response = response.filter((val) => val !== 'login_source');
                }

                if (!response.length) {
                    this.bookColumnsMap.set(tableName, expectedBookColumns);
                } else {
                    // as required only the saved value not need to search in column array for Showpromoteplan 
                    if (tableName !== ShowPromotePlan) {
                        // This is done to handle when a new column is added, that new column is not added in
                        // cached data in Database. So Remove any old column and add new Fixed column if any.
                        response = response.filter(col => expectedBookColumns.includes(col)).
                        concat(FROZEN_BOOKS_MAPPINGS[tableName].filter(col => !response.includes(col)))
                    }
                    this.bookColumnsMap.set(tableName, response);
                }
                return this.bookColumnsMap.get(tableName)
            })
        )
    }

    // To add select field (row checkbox)
    addSelectField(obj: SetCacheRequestParams): string[] {

        // obj.data.unshift('select');
        if ((obj.key === 'orderBook') || (obj.key === 'TradeBook')) {
            obj.data.unshift('strategy_type')
        } else if (obj.key === 'positionsBook') {
            obj.data.unshift('position_type')
        }
        return obj.data;
    }

    // To remove select field (row checkbox) from showing in show hide
    removeSelectField(fields: string[]): string[] {
        return remove(fields, el => { return el !== 'strategy_type' && el !== 'position_type' });
    }

    /**
     * FOR RA-1021
     * Before converting the @param sepatTableColumnsParams to string, select
     * is added.
     */
    setColumns(setTableColumnsParams: SetCacheRequestParams, addSelectedFields = true) {
        setTableColumnsParams.data = JSON.stringify(addSelectedFields ? this.addSelectField(setTableColumnsParams) : setTableColumnsParams.data);
        return this.http.post<any>(this.configurationService.applicationUrls.setCache, setTableColumnsParams).pipe(
            map(res => {
                this.bookColumnsMap.set(setTableColumnsParams.key, JSON.parse(setTableColumnsParams.data));
                return this.bookColumnsMap.get(setTableColumnsParams.key);
            })
        )
    }
    setDefaultColumns(displayedColumns: string[], bookDefaultColumns: string[], bookType: BookType) {
        const bookColumn = JSON.parse(JSON.stringify(bookDefaultColumns));
        const data = this.removeSelectField(bookColumn);
        if (displayedColumns.join() === bookDefaultColumns.join()) {
            return of(displayedColumns);
        }
        return this.setColumns({ key: bookType, data: data })
    }

    getPortfoliosLength(tableName: string) {
        return this.http.get<any>(this.configurationService.applicationUrls.getCache, {
            params: {
                key: tableName
            }
        })
    }

    setPortfoliosLength(keyLength: SetCacheRequestParams) {
        return this.http.post<any>(this.configurationService.applicationUrls.setCache, keyLength)
    }

}
